
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import TaksitDuzenleForm from "@/components/anakart/taksitlendirme/TaksitDuzenleForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {TaksitEntity} from "@/entity/TaksitEntity";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TaksitHesapAyarEntity} from "@/entity/TaksitHesapAyarEntity";
import {TakipEntity} from "@/entity/TakipEntity";
import OdemeTaahhuduTaslak from "@/components/OdemeTaahhuduTaslak.vue";
import TahsilatForm from "@/components/forms/TahsilatForm.vue";
import TaksitTahsilatDonustur from "@/components/forms/TaksitTahsilatDonustur.vue";
import {TAKSIT_TABLO_HEADERS} from "@/helpers/taksitTabloHeaders";
import {PlanOzeti, kayitliPlanOzetiHesapla} from "@/utils/taahhutTutarlari";

@Component({
  components: {TaksitTahsilatDonustur, TahsilatForm, OdemeTaahhuduTaslak, DeleteDialog, TaksitDuzenleForm, FormDialog}
})
export default class TaksitTaahutList extends Mixins(ObjectInputMixin) {
  @Prop() loading!: boolean;
  @Prop() takip!: TakipEntity;
  @Prop() items!: any

  @Prop({default: false}) yazdirGorunurluk!: boolean
  @Prop({default: 'Ödeme Detayları'}) baslikTaksit!: string
  @Prop() taksitler!:any
  @Ref("odemeTaahhuduTaslak")
  readonly odemeTaahhuduTaslak!: OdemeTaahhuduTaslak;

  get defaultValue(){
    let taksitlerArray:any = []
    this.taksitler.forEach((taksitler:any)=>{
      taksitlerArray.push(taksitler)
    })
    return taksitlerArray
  }

  dialog = false;
  isKartNoVisible: boolean = true;
  hesapAyar = JSON.parse(this.takip.taksit_hesap_ayar as unknown as string)
  headers = [
    ...TAKSIT_TABLO_HEADERS,
    {text: "İşlemler", value: "actions", sortable: false},
  ]

  // TDT-3234: özet şeridi ve PDF çıktısı evrakla aynı kaynaktan (bkz. planOzetiHesapla).
  // Eskiden ana_para/isleyen_faiz basılıyordu; BSMV'li planda "Borç Tutarı" evrakın Genel
  // Toplam'ından BSMV kadar fazla, "Faiz Tutarı" eksik görünüyordu. Satırlar "Tahsilata
  // Dönüştür" ile değiştiyse kayıtlı plan özeti kullanılır (bkz. kayitliPlanOzetiHesapla).
  get planOzeti(): PlanOzeti {
    return kayitliPlanOzetiHesapla(this.hesapAyar, this.items);
  }

  load(){
    this.$emit('updated')
  }


  ciktiAl() {
    this.$helper.printTaksitTablo({
      title: this.baslikTaksit,
      items: this.items || [],
      anaPara: this.hesapAyar == null ? null : this.planOzeti.borcTutari,
      isleyenFaiz: this.hesapAyar == null ? null : this.planOzeti.faizTutari,
    });
  }

  print() {
    //yazdırda üst ve alttaki tarih/about:blank yazılarını kaldırır
    const header = document.querySelector("header");
    const footer = document.querySelector("footer");
    if (header) {
      header.style.display = "none";
    }
    if (footer) {
      footer.style.display = "none";
    }
    this.odemeTaahhuduTaslak.print();

  }

  wordYazdir() {
    let belge: string = "";
    belge = "odemeTaahhuduTaslak";

    var header =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
        "xmlns:w='urn:schemas-microsoft-com:office:word' " +
        "xmlns='http://www.w3.org/TR/REC-html40'>" +
        "<head><meta charset='utf-8'></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header + (document.getElementById(belge)?.innerHTML) + footer;
    console.log(document.getElementById(belge));
    var source =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = belge + ".doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
  }

  onDialogChange(isOpen: boolean) {
    // Component handles its own data loading in mounted() hook
    // No need to manually trigger handleTaksitler() here
  }
}
